"use client";

import { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LogoIconRemediumBlue } from "@/svg/logo-icon-remedium-blue";
import { createPath } from "@/service/routing/routing";

export function ServerUpdatingPage({
  withInstantUpdate = false,
}: {
  withInstantUpdate?: boolean;
}) {
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (withInstantUpdate) {
      if (window.location.href !== "/logout") {
        window.location.href = "/logout";
      }
    }
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  if (withInstantUpdate) {
    return <></>;
  }

  return (
    <div className="font-inter bg-remedium-blue/5 flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mb-4 flex items-center justify-center">
            <div className="relative">
              <LogoIconRemediumBlue />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-zinc-800">
            Trwa aktualizacja
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-zinc-600">Portal jest tymczasowo niedostępny</p>

          <div className="border-t pt-4">
            <p className="mb-2 text-sm text-zinc-500">
              Ostatnia próba połączenia
            </p>
            <p className="font-mono text-lg font-semibold text-zinc-800">
              {formatTime(new Date())}
            </p>
          </div>

          <div className="flex justify-center">
            <div className="flex space-x-1">
              <div className="h-2 w-2 animate-pulse rounded-full bg-blue-500"></div>
              <div
                className="h-2 w-2 animate-pulse rounded-full bg-blue-500"
                style={{ animationDelay: "0.2s" }}
              ></div>
              <div
                className="h-2 w-2 animate-pulse rounded-full bg-blue-500"
                style={{ animationDelay: "0.4s" }}
              ></div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
